<!-- End Line Carousel Section-->
<div
  attr.pdlPageComponentId="{{ pdlPageComponentId }}"
  attr.pdlRepeatedComponent="{{ pdlRepeatedComponent }}"
>
  <router-outlet></router-outlet>
</div>
